import DLAnimate from 'dl-animate/dist/dl-animate-module';
import './FadeSlider.scss';

const defaults = {
  container: null,
  item: '[data-role*="fade-slider-slide"]',
  itemsToShow: 6,
  slideInterval: 3000,
  duration: document.documentElement.dataset.duration * 1000,
};


export default class {
  constructor(props) {
    const options = Object.assign({}, defaults, props);
    this.container = options.container;
    this.item = options.item;
    this.items = Array.from(this.container.querySelectorAll(this.item));
    this.shownItems = [];
    this.hiddenItems = [];
    this.itemsToShow = options.itemsToShow;
    this.slideInterval = options.slideInterval;
    this.duration = options.duration;
    this.animate = new DLAnimate();
    this.timeInterval = null;

    this.init();
  }

  swap() {
    const oldIndex = Math.floor(Math.random() * this.shownItems.length);
    const newIndex = Math.floor(Math.random() * this.hiddenItems.length);
    const oldElement = this.shownItems[oldIndex];
    const newElement = this.hiddenItems[newIndex];
    const insertBefore = this.shownItems[oldIndex + 1] || null;
    const toRemove = oldElement.cloneNode(true);


    this.shownItems[oldIndex] = newElement;
    this.hiddenItems[newIndex] = toRemove;
    this.animate.remove(oldElement, {
      name: 'fade-slider',
      track: 'none',
      duration: this.duration,
      afterLeave: (el) => {
        $(el).remove();
        this.animate.insert(this.container, newElement, {
          beforeEnter(nextElement) {
            const lazy = nextElement.querySelector('[data-lazy-loading="true"]');
            if (lazy) lazy.src = lazy.dataset.src;
          },
          name: 'fade-slider',
          track: 'none',
          duration: this.duration,
        }, insertBefore);
      },
    });
  }

  start() {
    clearInterval(this.timeInterval);
    this.timeInterval = setInterval(() => {
      this.swap();
    }, this.slideInterval);
  }

  init() {
    // exit when items < than can be shown
    if (this.items.length <= this.itemsToShow) return;

    this.items.forEach((item, i) => {
      if (i < this.itemsToShow) {
        this.shownItems.push(item);
      } else {
        const cloned = item.cloneNode(true);
        this.hiddenItems.push(cloned);
        $(item).remove();
      }
    });
    this.container.addEventListener('fade-slider-start', this.start.bind(this), { once: true });
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/FadeSlider/FadeSlider.js